export const CANDIDATE_FEEDBACK_STATUSES = {
    NONE: 'none',
    PENDING: 'pending',
    ACCEPTED: 'accepted',
    READY_FOR_SEND: 'ready_for_send',
};

export const EMPLOYER_STATUS_REASONS = {
    EMPLOYER_BACK_TO_FULL_SERVICE: 'employer_back_to_full_service',
};
